function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.67 29.773a3.67 3.67 0 0 1-2.603-6.273 3.63 3.63 0 0 1 2.583-1.067 3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.67 27.504a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.67 29.773a3.67 3.67 0 0 1-2.603-6.273 3.63 3.63 0 0 1 2.583-1.067 3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.67 27.504a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.67 29.773A3.67 3.67 0 0 1 5.067 23.5a3.63 3.63 0 0 1 2.583-1.067 3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.67 27.504a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7.67 29.773A3.67 3.67 0 0 1 5.067 23.5a3.63 3.63 0 0 1 2.583-1.067 3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.67 27.504a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M3 26.023H1v-7.59h77.67l-.1 4h-3.66l-.26 1.53-1.52-.12-.83-1.33-6-.09-.16-.75h-6.9l-13.71 2.94H21.36l-.09-.24a3.81 3.81 0 0 0-3.68-2.45 4.09 4.09 0 0 0-3.53 2.54l-.09.23h-2.75l-.1-.22a4.13 4.13 0 0 0-3.48-2.53h-.07a3.82 3.82 0 0 0-3.42 2.28l-.09.22H3v1.58zm-1.26-.71h.54v-1.6h1.31a4.57 4.57 0 0 1 4-2.5h.09a4.72 4.72 0 0 1 4 2.75h1.81a4.72 4.72 0 0 1 4.08-2.77 4.65 4.65 0 0 1 4.28 2.69h23.6l13.72-2.94h7.5l.17.76 5.87.08.85 1.36h.5l.25-1.48h3.6v-2.49H1.72l.02 6.14z",
  fill: "#E4ECFF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M77.49 18.953h-.72v3.11h.72v-3.11z",
  fill: "#E4ECFF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M77.13 19.513H1.38v.72h75.75v-.72zM43.74 23.863h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM37.17 23.863h-1.26v-2.87h1.29l-.03 2.87zm-.93-.36h.57v-2.15h-.57v2.15zM30.59 23.863h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM24.02 23.863h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM13.19 23.863h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM59.59 23.283h-3v-1.7l3.07-.48-.07 2.18zm-2.33-.72h1.65v-.62l-1.62.25-.03.37z",
  fill: "#E4ECFF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M58.91 24.973h-1.6v-2.37h1.56l.04 2.37zm-.88-.72h.15v-1h-.13l-.02 1zM58.91 28.543h-1.59v-3h1.59v3zm-.87-.72h.15v-1.65h-.15v1.65z",
  fill: "#E4ECFF"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M59.44 26.223h-2.75v-2h2.74l.01 2zm-2-.72h1.3v-.53h-1.3v.53zM59.42 29.073h-2.75v-1.27l2.75.02v1.25zM12.006 1.664c.272-1.237.8-1.656 2-1.659h4.613c1.374 0 1.786.302 2.22 1.668h.65c8.864 0 17.727.003 26.59.007.463 0 .725-.061.831-.605.121-.62.798-1.056 1.496-1.063 1.83-.015 3.67-.017 5.494 0 .726.008 1.348.47 1.495 1.153.095.448.309.515.696.512 2.08-.016 4.16 0 6.24-.021 1.164-.017 2.047.454 2.719 1.38.94 1.304 1.342 2.803 1.544 4.364.32 2.474.238 4.926-.603 7.302a8.598 8.598 0 0 1-.84 1.692c-.665 1.052-1.622 1.539-2.901 1.539-19.877-.016-39.754-.016-59.63 0-1.52 0-2.531-.65-3.252-1.903-.784-1.36-1.13-2.855-1.27-4.393-.214-2.364-.124-4.706.74-6.953.22-.568.503-1.11.845-1.613.653-.959 1.562-1.441 2.76-1.426 2.505.04 5.013.019 7.563.019zm.715.848v14.72h7.37V2.512h-7.37zM56.74 17.251V2.512H49.45v14.739h7.289zM27.787 2.509v14.709h6.507V2.509h-6.507zm7.252 0v14.723h6.45V2.509h-6.45zm7.214 0V17.23h6.466V2.512l-6.466-.003zM27.055 17.244V2.523H20.81v14.72h6.244zM6.132 2.31v14.917h5.829a.655.655 0 0 0 .06-.172l.02-14.136c0-.456-.288-.601-.64-.605C9.664 2.3 7.925 2.31 6.132 2.31zm51.346.18v14.737h5.709V2.49h-5.71zM5.39 17.227V2.364c-2.07-.233-3.006.232-3.747 2.11a13.575 13.575 0 0 0-.88 3.456c-.272 2.42-.194 4.846.835 7.119 1.064 2.35 1.938 2.351 3.792 2.179zM63.93 2.49v14.73c1.224.245 2.081-.22 2.692-1.187.282-.435.517-.9.701-1.384.865-2.37.952-4.816.615-7.288-.19-1.352-.544-2.655-1.31-3.806C65.996 2.599 65.5 2.5 63.93 2.49zm-14.464-.689h7.349C56.752.986 56.499.665 55.812.654a174.96 174.96 0 0 0-5.343 0c-.686.007-.94.336-1.003 1.147zm-36.67.018h7.262c0-.745-.262-1.14-.887-1.152a145.838 145.838 0 0 0-5.561 0c-.644.018-.884.423-.814 1.152z",
  fill: "#E4ECFF"
});

var SvgVacuumTrailer = function SvgVacuumTrailer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 30,
    viewBox: "0 0 79 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVacuumTrailer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vacuumTrailer.d16918e4.svg";
export { ForwardRef as ReactComponent };